<template>
  <section class="datatable__container">
    <transition-group name="fade" mode="out-in">
      <dr-loader
        v-if="!loaded"
        key="loader"
        size="lg"
        class="flex-center"
      />

      <template v-if="getRows.length > 0">
        <datatable
          ref="datatable"
          key="datatable"
          :columns="columns"
          :page="currentPage"
          :per-page="1000"
          :filter-by="filterBy"
          :data.sync="getRows"
          :buttons="['copy', 'csv', 'excel', 'pdf', 'print']"
          class="datatable__table datatable__table--stripped"
        >
          <template slot-scope="{ row }">
            <tr
              @click="selectedRow === row.id ? selectedRow = null : selectedRow = row.id"
              :class="selectedRow === row.id ? 'selected-row' : ''"
              class="datatable__row"
            >
              <template v-for="(rowVal,rowName, $index) in orderRow(row)">
                <td
                  v-show="rowName !== 'key' && !getProp(columns, rowName, 'hide')"
                  :key="'row' + $index"
                  :class="getProp(columns, rowName, 'class') + ' ' + ( 'text-' + getProp(columns, rowName, 'align')) || ''"
                  class="datatable__cell"
                >
                  <span v-if="getProp(columns, rowName, 'image')">
                    <img :src="rowVal | ADD_IMG_PATH" style="width: 60px" />
                  </span>

                  <span v-else-if="getProp(columns, rowName, 'action') === 'appointment'">
                    <template>
                      <router-link
                        v-if="fn_IS_DOCTOR() && appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) !== 5"
                        :to="`../${fn_GET_PARENT_ROUTE($route, 'Doctor').toLowerCase()}/${row.patientType}/${rowVal}/${row.agendaId}`"
                        :key="`status_${appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId)}`"
                        class="appointment__list-item"
                      >
                        <template v-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 1">
                          <i class="label label--green">Consulta em andamento</i>
                        </template>

                        <template v-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 2">
                          <i class="label label--blue">
                            Iniciar
                          </i>
                        </template>
                        <template v-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 3">
                          <i class="icon icon-search" />
                        </template>

                        <template v-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 4">
                          <i class="label label--green">
                            Atendimento realizado
                          </i>
                        </template>

                        <template v-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 6">
                          <i class="label label--red">
                            Não compareceu
                          </i>
                        </template>
                      </router-link>

                      <template v-else-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 5">
                        <i class="label label--red">
                          Atendimento cancelado
                        </i>
                      </template>

                      <!-- <router-link v-else :to="`/secretary/doctor/${$route.params.doctorId}/appointments/${row.patientType}/${rowVal}/${row.agendaId}`">
                        <i class="icon icon-search" />
                      </router-link> -->

                      <template v-if="appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 2">
                        <i @click="confirmAbsent(row)" class="label label--blue clickable">
                          Inf. Ausência
                        </i>
                      </template>
                    </template>
                  </span>

                  <span v-else-if="getProp(columns, rowName, 'action') === 'label'" class="text-center">
                    <i :class="fn_PROCEDURES_STATUS_CLASS(row.status)" class="label">
                      {{row.status}}
                    </i>
                  </span>

                  <span v-else-if="getProp(columns, rowName, 'action') === 'view'" class="text-center">
                    <router-link
                      :to="
                        (fn_IS_DOCTOR()
                          ? `/doctor/`
                          : `/secretary/doctor/${$route.params.doctorId}/`) + `patients/details/${$route.params.type || 'patient'}/${rowVal}`"
                    >
                      <i class="icon icon-search" />
                    </router-link>
                  </span>

                  <span v-else-if="getProp(columns, rowName, 'action') === 'edit'" class="text-center">
                    <a
                      style="position: relative; margin-top: 0px"
                      class="btn btn-primary btn-sm"
                      @click="$emit('edit',row.id)"
                    >
                      Ver detalhes
                    </a>
                  </span>

                  <span v-else-if="getProp(columns, rowName, 'action') === 'remove'" class="text-center">
                    <!-- para esconder este campo, transformar id em string -->
                    <a v-if="Number.isInteger(row.id)" @click="$emit('remove',row.id)">
                      <dr-icon color="red" name="excluiAlerta" />
                    </a>
                  </span>

                  <span v-else-if="getProp(columns, rowName, 'boolean')">
                    {{ getProp(columns, rowName, 'boolean')[rowVal] || getProp(columns, rowName, 'boolean').false }}
                  </span>

                  <span v-else-if="rowName === 'type'" class="d-flex" >
                    {{ getFilter(rowName, rowVal) | REMOVE_UNDERSCORE | TO_CAPITALIZE }}

                    <template v-if="rowVal === 'CONVENIO'">
                      <router-link v-if="fn_IS_DOCTOR_FACILITIES()" :to="{ name: fn_IS_SECRETARY() ? 'SecretaryAppointmentsGuide' : 'DoctorAppointmentsGuide', params: { agendaId: row.agendaId } }">
                        <dr-icon name="reports" color="#56bdd2" class="table__icon" />
                      </router-link>
                    </template>
                  </span>

                <span v-else :class="rowName === 'name' ? 'highlight' : ''">
                    <!-- Caso seja médico -->
                    <template v-if="fn_IS_DOCTOR()">
                      <!-- Caso a coluna seja igual a nome -->
                      <router-link
                        v-if="rowName === 'name' && row.id"
                        :to="{ name: 'DoctorPatientsDetails', params: { patientType: $route.params.type, id: row.id } }"
                      >
                        {{ getFilter(rowName, rowVal) || '(não informado)' | REMOVE_UNDERSCORE | TO_CAPITALIZE }}
                      </router-link>
                      <!-- Demais colunas -->
                      <template v-else>
                        {{ getFilter(rowName, rowVal) || '(não informado)' | REMOVE_UNDERSCORE | TO_CAPITALIZE | CHECK_HOURS }}
                      </template>
                    </template>
                    <!-- Caso seja secretária -->
                    <template v-else>
                      <!-- Caso a coluna seja igual a nome -->
                      <router-link
                        v-if="rowName === 'name'"
                       :to="{ name: 'SecretaryPatientsDetails', params: { patientType: $route.params.type, id: row.id } }"
                      >
                        {{ getFilter(rowName, rowVal) || '(não informado)' }}
                      </router-link>
                      <!-- Demais colunas -->
                      <template v-else>
                        {{ getFilter(rowName, rowVal) || '(não informado)' }}
                      </template>
                    </template>
                  </span>
                </td>

                <td
                  :key="'notification_'+$index"
                  v-if="getProp(columns, rowName, 'action') && fn_IS_SECRETARY() && $route.path.indexOf('appointments') > 1"
                  class="datatable__cell datatable__cell--icon"
                >
                  <small
                    @click="sendNotification(row)"
                    v-if="
                      appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 2 &&
                      (sentNotifications.indexOf(row.agendaId) === -1)
                    "
                    class="text-error clickable"
                  >
                    <i class="icon icon-message" />
                    <strong>Notificar chegada</strong>
                  </small>

                  <br />

                  <small
                    v-if="
                      appointmentStatus(getProp(columns, rowName, 'appointmentField'), row.agendaId) === 2
                      && sentNotifications.indexOf(row.agendaId) > -1
                    "
                    class="text-success clickable"
                  >
                    <i class="icon icon-check" />

                    <strong>Notificação enviada</strong>
                  </small>
                </td>

                <td
                  v-if="
                    getProp(columns, rowName, 'action') &&
                    $route.path.indexOf('/patients/list/specialPatient') > -1
                  "
                  :key="'editSpecial'+$index"
                  class="datatable__cell datatable__cell--icon"
                >
                  <a @click="$emit('edit',row.id)">
                    <i class="icon icon-edit" />
                  </a>
                </td>
              </template>
            </tr>
          </template>
        </datatable>
      </template>

      <h2
        v-if="loaded && getRows.length === 0"
        key="no-data-msg"
        class="datatable__no-data"
      >
        Não há dados.
      </h2>
    </transition-group>

    <!-- <footer class="pagination flex-middle flex-end" >
      <datatable-pager :ref="'datatablePager'" v-if="loaded" type="abbreviated" class="wrapper pagination" v-show="getRows.length > getPerPage" v-model="currentPage" ></datatable-pager>
    </footer> -->
  </section>
</template>

<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  props: [ 'columns', 'rows', 'page', 'perPage', 'filterBy', 'row', 'rowData', 'expand', 'doctor', 'url' ],

  filters: {
    'CHECK_HOURS': (val) => {
      if (/às/gi.test(val)) {
        return String(val).toLowerCase()
      }

      return val
    }
  },

  data () {
    return {
      localRows: [],
      localRowData: [],
      updateTable: false,
      currentPage: 1,
      sentNotifications: [],
      selectedRow: null,
      getTransition: 'fade',
      getTransition2: 'slide-down',
      loaded: false,
      expanded: null,
      loaded2: false
    }
  },
  mounted () {
    if (!this.rows) {
      return
    }
    this.getRows = this.rows
    if (this.rows.length > 0) {
      this.loaded = true
      this.fn_SORT_LISTENERS()
    }
  },
  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    getRoute () {
      return this.$route.name
    },
    getPerPage () {
      return this.perPage || 10
    },
    getPage () {
      return this.currentPage
    },
    getCustomer () {
      return this.$store.getters.getParentObj.customerId
    },
    getRowData: {
      get () {
        return this.localRowData
      },
      set (v) {
        this.localRowData = v
      }
    },
    getRows: {
      get () {
        return this.localRows
      },
      set (rows) {
        let key = 0
        this.localRows = []
        for (let row of rows) {
          if (this.fn_IS_OBJ(row)) {
            this.localRows.push(row)
            this.localRows[key].key = key
            key++
          }
        }
        this.loaded = true
      }
    }
  },
  watch: {
    'rows': function (next, prev) {
      this.loaded = false
      this.getRows = next
      this.loaded = true
    },
    rowData (next, prev) {
      const self = this
      self.getRowData = next
      setTimeout(() => {
        self.loaded2 = true
      }, 1500)
    },
    'currentPage': function (next, prev) {
      if (next > prev) {
        this.getTransition = 'fade_left'
      } else {
        this.getTransition = 'fade_right'
      }
    }
  },
  methods: {
    expandRow (id, y, m) {
      const self = this
      self.loaded2 = false
      setTimeout(function () {
        self.getRowData = []
        if (self.expanded !== id) {
          self.$refs.datatable.$parent.$parent.$emit('expand', [y, m])
          self.expanded = id
        } else {
          self.expanded = null
        }
      }, 400)
    },
    sendNotification (agenda) {
      const self = this
      function confirmed () {
        self.fn_SHOW_PROGRESS()
        self.$http.get(`/secretary/doctor/${self.$route.params.doctorId}/doctor_office/${agenda.doctorOfficeId}/agenda/${agenda.agendaId}/arrival_notification`, self.$store.getters.getAuthHeader).then(
          (res) => {
            console.log(res)
            self.sentNotifications.push(agenda.agendaId)
          }
        ).catch(
          (err) => {
            console.log(err)
          }
        ).finally(
          () => {
            self.fn_HIDE_PROGRESS()
          }
        )
      }
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: 'Confirma o envio da notificação ao paciente?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (v) {
            confirmed()
          }
          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },
    appointmentStatus (appointmentField, id) {
      for (let row of this.getRows) {
        if (row.agendaId === id) {
          if (row.status !== 'REALIZADO') {
            if (
              row.status.indexOf('CANCELADO PELO MÉDICO') === -1 &&
              !/compareceu/gi.test(row.status) &&
              this.$moment(row.agendaAppointmentStart).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD')
            ) {
              if (row.status === 'EM ANDAMENTO') {
                return 1 // em andamento
              } else {
                return 2 // iniciar consulta
              }
            } else {
              if (row.status.includes('CANCELADO')) {
                return 5 // cancelado
              } else {
                if (row.status.includes('COMPARECEU')) {
                  return 6 // não compareceu
                } else {
                  return 3 // lupa
                }
              }
            }
          } else {
            return 4 // consulta finalizada
          }
        }
      }
    },
    proceduresStatusLabelClass (status) {
      this.fn_PROCEDURES_STATUS_CLASS(status)
    },
    getFilter (rowName, rowValue) {
      if (this.getProp(this.columns, rowName, 'filter')) {
        return this.$root.$options.filters[this.getProp(this.columns, rowName, 'filter')](rowValue)
      } else {
        return rowValue
      }
    },
    orderRow (row) {
      let obj = {}
      let key = 0
      for (let col of this.columns) {
        obj[col.field] = row[col.field]
        if (this.rowData) {
          obj.key = key++
        }
      }
      return obj
    },
    changePage (v) {
      if ((v < 0 && this.currentPage === 1) || (v > 0 && this.currentPage === Math.floor(this.getRows / this.perPage))) {
        return
      }
      this.currentPage = this.currentPage + v
    },
    updateRows () {
      this.getRows = null
    },
    mutateForm (id) {
      let updateObj = {}
      updateObj.activeId = id
      updateObj['active' + this.customerForm] = this.customerForm + 'Form'
      this.$store.dispatch('reloadDatatables')
      this.$store.dispatch('updateParentObj', updateObj)
    },
    mutateList (id) {
      let updateObj = {}
      updateObj.eventId = id
      updateObj.activeTab = 'stocks'
      this.$store.dispatch('updateParentObj', updateObj)
    },
    deleteRow (row) {
      this.$emit('removeRow', row)
    },
    checkInt (cols, field) {
      for (let col of cols) {
        if (col.field === field) {
          return col.intType
        }
      }
    },
    getProp (cols, field, prop) {
      for (let col of cols) {
        if (col.field === field) {
          return col[prop]
        }
      }
    },
    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Aviso',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    confirmAbsent (agenda = null) {
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: 'Deseja confirmar o não comparecimento do paciente?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.sendingAbsent(agenda)
          }
          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    sendingAbsent (agenda) {
      if (agenda) {
        const url = `/doctor/doctor_office/${agenda.doctorOfficeId}/agenda/${agenda.agendaId}/absent`
        this.fn_SHOW_PROGRESS()
        this.sending = true
        this.loaded = true
        this.$http
          .put(
            url,
            { status: { status: true } },
            this.$store.getters.getAuthHeader
          )
          .then((res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Status de não comparecimento registrado com sucesso.',
              size: 'md',
              active: true
            })
          })
          .catch((err) => {
            console.log('err \n', err)
            this.handleError(err)
          })
          .finally(() => {
            this.fn_HIDE_PROGRESS()
            this.sending = false
            this.loaded = false
            EventBus.$emit('fetch-appointments-list')
          })
      }
    }
  }
}

</script>
